module.exports = __webpack_public_path__ + "static/media/reset.e0e98a71.png";